<template>
  <div class="no-found" >
    <img class="img" src="../../assets/images/yidong4.svg" style="width: 200.434px;height: 150.225px;"/>
    <img class="img" src="../../assets/images/yidong5.svg"  style="height: 42px;width: 100%; margin-top: 10px;margin-left: -8px"  />
  </div>
</template>
<script>
import '../../utils/wwLogin'
// import md5 from 'js-md5'
// import { apiUrl } from '@/config/constant'
export default {
  data() {
    return {
      isShow: false,
      id: 1
    }
  },
  mounted() {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    const a = localStorage.getItem('corpid')
    if (flag) {
      // 手机端
      // const b = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + a + '&redirect_uri=http%3A%2F%2Fweyun-test-web.tyunai.cn%2Fapi%2Fshow%2Fmobile%2Fuserinfo&response_type=code&scope=snsapi_base&state=' + '#wechat_redirect'
      // console.log('https://open.weixin.qq.com/connect/oauth2/authorize?appid=${a}&redirect_uri=https%3A%2F%2Fweyun-dev-web.tyunai.cn%2Fapi%2Fshow%2Fmobile%2Fuserinfo&response_type=code&scope=snsapi_base&state=a#wechat_redirect')
      // window.location.href = b
      this.isShow = true
      return true
    }
  },
  methods: {
    getWith() {
      if (document.body.clientWidth <= 1400) {
        this.id = 2
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.grid-content{

  .image{
    width: 10.125rem;
    height: 2.838125rem;
    margin-top: 37px;
    margin-left: 38px;
  }
  .content{
    display: flex;
    margin-top:105px;
    margin-left:200px;
    .ty{
      width: 392px;
      padding: 8px;
      text-align:left;
      .wenzi{
        width: 390px;
        height: 60px;
        word-break: break-all;
        font-size: 60px;
        line-height: 32px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #204A9E;
        text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
        letter-spacing: 5px;
        opacity: 1;
      }
      .zi{
        width: 392px;
        height: 27px;
        font-size: 25.5px;
        margin-top: -10px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #204A9E;
        text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
        opacity: 1;
      }
    }
    .xian{
      width: 3px;
      height: 87px;
      margin-left: 16px;
      background: #204A9E;
      opacity: 1;
    }
    .td{
      margin-left: 26px;
      .hui{
        width: 256px;
        height: 40px;
        font-size: 32px;
        font-weight: 400;
        line-height: 40px;
        color: #204A9E;
        text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
        opacity: 1;
      }
      .shu{
        width: 256px;
        height: 40px;
        font-size: 32px;
        font-weight: 400;
        line-height: 40px;
        color: #204A9E;
        text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
        opacity: 1;
      }
    }
  }
  .tw{
    display: flex;
    margin-top: 107px;
    margin-left: 200px;
    .hy{
      padding: 0 -31px;
      //  border: 1px dashed black;
    }
    .de{
      width:180px;
      word-wrap:break-word;
      font-size: 20px;
      margin-top: 150px;
      margin-left: 31px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 14px;
      color: #8D99A3;
      text-shadow: 1px 1px 1px rgba(141, 153, 163, 0.12);
      opacity: 1;
    }
    .ki{
      width:325px;
      word-wrap:break-word;
      font-size: 20px;
      margin-top: 40px;
      margin-left: 31px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 14px;
      color: #8D99A3;
      text-shadow: 1px 1px 1px rgba(141, 153, 163, 0.12);
      opacity: 1;
    }
  }
}
.right {
  position: absolute;
  top: 220px;
  right: 7%;
  width: 350px;
  text-align: center;
  // background: #fff;
  // box-shadow: 0px 0px 40px 0px rgba(2, 47, 50, 0.1);
  border-radius: 10px;
  z-index: 999;
  // text-align: rigth;
  .er{
    width: 320px;
    //height: 18.75rem;
    // margin-top: 210px;
    padding: 24px;
    text-align: center;
    background: linear-gradient(210deg, #204A9E 0%, #1A3C81 100%);
    box-shadow: 0px 10px 30px rgba(0, 22, 67, 0.4);
    opacity: 1;
    border-radius: 20px;
    .wei{
      width: 320px;
      height: 385px;
      background: #FFFFFF;
      box-shadow: 0px 0px 30px rgba(0, 22, 67, 0.51);
      opacity: 1;
      border-radius: 12px;
      padding-top: 15px;
    }
  }
  h2 {
    font-size: 36px;
    font-weight: bold;
    color: #06c1db;
  }
}
.footer{
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin-top: 7%;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 37px;
  color: #204A9E;
  opacity: 0.8;
  div{
    height: 15px;
  }
}

.no-found {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  //.img{
  //  width: 258.04px;
  //  height: 266.03px;
  //
  .container33 {
    position: relative;
  }
  .text {
    position: absolute;
    top: 4px; /* 根据需要调整距离 */
    left: 7%;
    font-size: 10.5px;
    width: 300px;
    //transform: translateX(-50%);
    //width: 300px;height: 40px;font-weight: 400;
    color: #204A9E;
    line-height: 18px
  }
  .text1 {
    position: absolute;
    top: 8px; /* 根据需要调整距离 */
    left:23%;
    font-size: 10.5px;
    width: 300px;
    //transform: translateX(-50%);
    //width: 300px;height: 40px;font-weight: 400;
    color: #204A9E;
    line-height: 16px
  }
  //.ti{
  //  height: 33px;
  //  font-size: 24px;
  //  font-weight: 500;
  //  line-height: 20px;
  //  color: #27282D;
  //  opacity: 1;
  //}
}
::v-deep .impowerBox .qrcode {
  width: 230px;
  vertical-align: top;
}
.vfbd{
  width: 100%;
  margin: 37px 38px;
  .buh{
    width: 100%;
    display: flex;
    align-items: center;
    .dfgu{
      width: 50%;
      // padding-left: 38px;
      .image{
        width: 162px;
        height: 45.41px;
      }
    }
    .dfhu{
      width: 50%;
      text-align: right;
      padding-right: 38px;
    }
  }
  .sdfgs{
    width: 100%;
    .content{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 79px;
      .ty{
        text-align:left;
        .wenzi{
          height: 50px;
          word-break: break-all;
          font-size: 41px;
          line-height: 32px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #204A9E;
          text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
          letter-spacing: 5px;
          opacity: 1;
        }
        .zi{
          font-size: 16px;
          margin-top: -10px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #204A9E;
          letter-spacing: 1.2px;
          text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
          opacity: 1;
        }
      }
      .xian{
        width: 2px;
        height: 60px;
        margin-left: 11px;
        background: #204A9E;
        opacity: 1;
      }
      .td{
        margin-left: 11px;
        .hui{
          font-size: 22px;
          font-weight: 400;
          color: #204A9E;
          text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
          opacity: 1;
        }
        .shu{
          font-size: 22px;
          font-weight: 400;
          line-height: 35px;
          color: #204A9E;
          text-shadow: 1px 1px 1px rgba(0, 22, 67, 0.2);
          opacity: 1;
        }
      }
    }
    .nkoyt{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      .center {
        text-align: center;
        border-radius: 10px;
        .er{
          width: 320px;
          padding: 24px;
          text-align: center;
          background: linear-gradient(210deg, #204A9E 0%, #1A3C81 100%);
          box-shadow: 0px 10px 30px rgba(0, 22, 67, 0.4);
          opacity: 1;
          border-radius: 20px;
          .wei{
            width: 320px;
            height: 385px;
            background: #FFFFFF;
            box-shadow: 0px 0px 30px rgba(0, 22, 67, 0.51);
            opacity: 1;
            border-radius: 12px;
            padding-top: 15px;
          }
        }
        h2 {
          font-size: 36px;
          font-weight: bold;
          color: #06c1db;
        }
      }
    }
  }
}

</style>
